import { render } from "./WhitelistedElementForm.vue?vue&type=template&id=6b2cfdb0&scoped=true"
import script from "./WhitelistedElementForm.vue?vue&type=script&lang=js"
export * from "./WhitelistedElementForm.vue?vue&type=script&lang=js"

import "./WhitelistedElementForm.vue?vue&type=style&index=0&id=6b2cfdb0&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2cfdb0"]])

export default __exports__